import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  settingsHeaderBadge: {
    background: "#38cfc4 !important",
    color: "#fff",
    borderRadius: 20,
    padding: "4px 8px",
    marginRight: 8,
  },
  settingsHeaderVersion: {
    color: "#465869",
    fontSize: 12,
    lineHeight: "16px",
    fontWeight: "normal",
  },
}));

export default styles;
